import { render } from "./ProductCategorySetting.vue?vue&type=template&id=5e193874&scoped=true"
import script from "./ProductCategorySetting.vue?vue&type=script&lang=js"
export * from "./ProductCategorySetting.vue?vue&type=script&lang=js"

import "./ProductCategorySetting.vue?vue&type=style&index=0&id=5e193874&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e193874"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ProductCategorySetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e193874"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e193874', __exports__)) {
    api.reload('5e193874', __exports__)
  }
  
  module.hot.accept("./ProductCategorySetting.vue?vue&type=template&id=5e193874&scoped=true", () => {
    api.rerender('5e193874', render)
  })

}


export default __exports__